<ion-menu side="end" type="push" contentId="main" swipeGesture="false">
  <ion-content>
    <header class="menu-header">
      <div class="menu-toolbar">
        <button class="close-icon" (click)="closeSideMenu()">
          <ion-icon name="close"></ion-icon>
        </button>
      </div>
    </header>

    <div class="menu-content">
      <div class="menu-list">
        <div *ngFor="let item of mobileAppMenuTabs" class="menu-item">
          <button class="menu-button" (click)="handleNavigation(item)">
            {{ item.title }}
          </button>
        </div>

        <div class="menu-item">
          <button class="menu-button" [disabled]="!paymentStore.verificationCustomer" (click)="navigateToAccount()">
            Account
          </button>
        </div>

        <div class="menu-item">
          <button class="menu-button" [disabled]="!paymentStore.verificationCustomer" (click)="showRemoveAccountAlert()">
            Remove Account
          </button>
        </div>
      </div>
    </div>
  </ion-content>
</ion-menu>
